import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import CustomStore from 'devextreme/data/custom_store';
import { ToastService } from 'ng-uikit-pro-standard';
import { OpenPunchListService } from 'src/app/services/open-punch-list.service';
import { TaskService } from 'src/app/services/task.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import Popup from 'devextreme/ui/popup';
import { TranslateService } from '@ngx-translate/core';
import { MapInformationService } from "src/app/services/map-information.service";

@Component({
  selector: 'app-new-push-list-item',
  templateUrl: './new-push-list-item.component.html',
  styleUrls: ['./new-push-list-item.component.scss']
})
export class NewPushListItemComponent implements OnInit {
  newPunchList: FormGroup;
  hasproject = false;
  now = new Date();
  projectslist: any;


  @Input() projectid: any;
  private _projectInfo: any;

  @Input('projectInfo')
  set projectInfo(projectInfo: any) {
    this._projectInfo = projectInfo;

    if (this.newPunchList && projectInfo) {
      console.log(this._projectInfo)
      this.newPunchList.get('Project').setValue(projectInfo.NAME);
      this.hasproject = true;
    }
    // if (projectInfo && projectInfo.projectInfoid > 0)
    // this.setprojectInfoInfo(projectInfo);
  }

  get projectInfo(): any { return this._projectInfo; }


  @Input() popupOpenPunchList = false;
  @Output() onmodalhidden = new EventEmitter<any>();
  @Output() onsubmit = new EventEmitter<any>();

  todayButton: any;
  prevDateButton: any;
  nextDateButton: any;

  todayButtonReview: any;
  prevDateButtonReview: any;
  nextDateButtonReview: any;

  todayButtonClose: any;
  prevDateButtonClose: any;
  nextDateButtonClose: any;

  millisecondsInDay = 24 * 60 * 60 * 1000;

  cancelButton: any;
  saveButton: any;
  dateFormat: any;

  constructor(
    private openPunchList: OpenPunchListService,
    private toast: ToastService,
    private taskService: TaskService,
    private appconfig: AppConfigService,
    private MapInformationService: MapInformationService,
    private translate:TranslateService) {
      this.dateFormat = this.appconfig.dateFormat;

      Popup.defaultOptions({
        device: { deviceType: "phone" },
        options: {
          fullScreen: true
        }
      });

    }

  ngOnInit() {
    this.initForm();

    this.GetEmployeesAll()

    this.cancelButton = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupOpenPunchList = false;
        this.close();
      },
    };

    this.saveButton = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.savePunchList();
      },
    };

    let mythis = this;
    this.projectslist = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        return mythis.taskService.GetProjectByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });


    this.todayButton = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        //this.now = new Date();
        this.newPunchList.get('OpenDate').setValue(new Date());
        // this.modelRelease.date = this.convertdate(this.now.getTime() - this.millisecondsInDay)
      }
    };
    this.prevDateButton = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        // this.now = new Date(this.now) 14289532
        let date = this.newPunchList.get('OpenDate').value;

        date = date ? date : new Date();
        this.newPunchList.get('OpenDate').setValue(this.convertdate(date.getTime() - this.millisecondsInDay));
      }
    };

    this.nextDateButton = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        //this.now = new Date(this.now)
        let date = this.newPunchList.get('OpenDate').value;

        date = date ? date : new Date();
        this.newPunchList.get('OpenDate').setValue(this.convertdate(date.getTime() + this.millisecondsInDay));
      }
    };


    this.todayButtonReview = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        this.now = new Date();
        this.newPunchList.get('ReviewedDate').setValue(new Date());
        // this.modelRelease.date = this.convertdate(this.now.getTime() - this.millisecondsInDay)
      }
    };
    this.prevDateButtonReview = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        // this.now = new Date(this.now) 14289532
        let date = this.newPunchList.get('ReviewedDate').value;

        date = date ? date : new Date();
        this.newPunchList.get('ReviewedDate').setValue(this.convertdate(date.getTime() - this.millisecondsInDay));
      }
    };

    this.nextDateButtonReview = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        //this.now = new Date(this.now)
        let date = this.newPunchList.get('ReviewedDate').value;

        date = date ? date : new Date();
        this.newPunchList.get('ReviewedDate').setValue(this.convertdate(date.getTime() + this.millisecondsInDay));
      }
    };


    this.todayButtonClose = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        this.now = new Date();
        this.newPunchList.get('CloseDate').setValue(new Date());
        // this.modelRelease.date = this.convertdate(this.now.getTime() - this.millisecondsInDay)
      }
    };
    this.prevDateButtonClose = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        // this.now = new Date(this.now) 14289532
        let date = this.newPunchList.get('CloseDate').value;

        date = date ? date : new Date();
        this.newPunchList.get('CloseDate').setValue(this.convertdate(date.getTime() - this.millisecondsInDay));
      }
    };

    this.nextDateButtonClose = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        //this.now = new Date(this.now)
        let date = this.newPunchList.get('CloseDate').value;

        date = date ? date : new Date();
        this.newPunchList.get('CloseDate').setValue(this.convertdate(date.getTime() + this.millisecondsInDay));
      }
    };
  }

  employeeListAll = []
  GetEmployeesAll() {
    let info = {
      method: 'Get_EmployeeListAll'
    }

    this.MapInformationService.MethodCallApiFlex(info).subscribe((result: any) => {
      this.employeeListAll = result
    })
  }

  CancelPopup(){
    this.popupOpenPunchList = false;
    this.close();
  }

  convertdate(str) {
    var date = new Date(str)
    var day: any = date.getDate()
    var month: any = date.getMonth() + 1;
    return new Date([date.getFullYear(), month, day].join("-") + " 00:00:00");
  }

  // popup punch list
  initForm() {
    console.log('Open Popup')
    // this.popupOpenPunchList = true;
    let today = new Date(Date.now())

    let projectname = this.projectInfo ? this.projectInfo.NAME : '';
    let itemName =  this.projectInfo ? this.projectInfo.itemname : '';
    // console.log(projectname)
    // console.log(this.projectInfo.name)
    // console.log(this.projectInfo)
    this.newPunchList = new FormGroup({
      Project: new FormControl(projectname, []),
      ItemName: new FormControl(itemName, []),
      OpenDate: new FormControl(today, []),
      Responsible: new FormControl('', []),
      Reviewed: new FormControl('', []),
      ReviewedDate: new FormControl('', []),
      Closed: new FormControl('', []),
      CloseDate: new FormControl('', []),
      Description: new FormControl('', []),
      Resource: new FormControl('', []),
    })

  }

  close() {
    this.popupOpenPunchList = false;
    this.onmodalhidden.emit();
    this.initForm();
  }

  savePunchList(){
    let form = this.newPunchList.value;
    let idUser = localStorage.getItem('customerid');
    let itemReviewed;
    form.Reviewed == true ? itemReviewed = 1: itemReviewed = 0;

    if(!this.projectid) {
      this.toast.warning(this.translate.instant('msgProjName'));
      return;
    }

    console.log(form);
    this.openPunchList.InsertUpdateOpenItem(this.projectid, form.ItemName, form.OpenDate, form.Responsible,  itemReviewed, form.ReviewedDate, form.Closed, form.CloseDate, form.Description, form.Resource)
    .subscribe(result=>{
      this.toast.success(this.translate.instant('msgOpItInfoUpdSucc'));
      this.onsubmit.emit();
      this.newPunchList.reset();
      this.popupOpenPunchList = false;
    })
  }

  updateProjectInfo(ev) {
    console.log(ev);
    if(ev.selectedItem)
      this.projectid = ev.selectedItem.ID;
    else
    this.projectid = 0;
  }

}
